import { apiSlice } from '../../apiSlice';

export const buildingApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['Building', 'Subscription'],
  endpoints: (builder) => ({
    postBuilding: builder.mutation({
      query: (building) => ({
        url: '/Building',
        method: 'POST',
        body: { ...building },
      }),
      invalidatesTags: ['Building'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),
    getBuildings: builder.query({
      query: () => {
        return {
          url: `/Building?orderby=BuildingId&top=10000`,
        };
      },
      providesTags: ['Building', 'Subscription'],
    }),
    getBuildingsByAccount: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Building?orderby=BuildingId&Account.AccountId=eq(${accountId})&top=10000`,
        };
      },
      providesTags: ['Building', 'Subscription'],
    }),
    getBuildingById: builder.query({
      query: (args) => {
        const buildingId = args;
        return {
          url: `/Building/${buildingId}`,
        };
      },
      providesTags: ['Building', 'Subscription'],
    }),
    postSubscriptionOnBuilding: builder.mutation({
      query: (args) => {
        const { buildingId, subscriptionId } = args;
        return {
          url: `/Building/${buildingId}/JobSubscriptions/${subscriptionId}`,
          method: 'POST',
        };
      },
      invalidatesTags: ['Building', 'Subscription'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),
    deleteSubscriptionOnBuilding: builder.mutation({
      query: (args) => {
        const { buildingId, subscriptionId } = args;
        return {
          url: `/Building/${buildingId}/JobSubscriptions/${subscriptionId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['Building', 'Subscription'],
    }),
    postBillingMeterOnBuilding: builder.mutation({
      query: (args) => {
        const { buildingId, billingMeter } = args;
        return {
          url: `/Building/${buildingId}/BillingMeters`,
          method: 'POST',
          body: { ...billingMeter },
        };
      },
      invalidatesTags: ['Building', 'Subscription'],
    }),
    getBillingMetersByBuilding: builder.query({
      query: (args) => {
        const buildingId = args;
        return {
          url: `/Building/${buildingId}/BillingMeters`,
          method: 'GET',
        };
      },
      providesTags: ['Building'],
    }),
    deleteBillingMeterOnBuilding: builder.mutation({
      query: (args) => {
        const { buildingId, billingMeterId } = args;
        return {
          url: `/Building/${buildingId}/BillingMeters/${billingMeterId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['Building', 'Subscription'],
    }),
    getCurrentHeatingStateOnBuilding: builder.query({
      query: (args) => {
        const buildingId = args;
        return {
          url: `/Building/${buildingId}/IsControlActive`,
          method: 'GET',
        };
      },
      // providesTags: ['Building']
    }),
    updateBuilding: builder.mutation({
      query: (args) => {
        const { buildingId, building } = args;
        return {
          url: `/Building/${buildingId}`,
          method: 'PUT',
          body: { ...building },
        };
      },
      invalidatesTags: ['Building'],
    }),
  }),
});

export const {
  usePostBuildingMutation,
  useGetBuildingsQuery,
  useGetBuildingsByAccountQuery,
  useLazyGetBuildingsByAccountQuery,
  useGetBuildingByIdQuery,
  useLazyGetBuildingByIdQuery,
  usePostSubscriptionOnBuildingMutation,
  useDeleteSubscriptionOnBuildingMutation,
  usePostBillingMeterOnBuildingMutation,
  useGetBillingMetersByBuildingQuery,
  useDeleteBillingMeterOnBuildingMutation,
  useGetCurrentHeatingStateOnBuildingQuery,
  useLazyGetCurrentHeatingStateOnBuildingQuery,
  useUpdateBuildingMutation,
} = buildingApiSlice;
